import * as React from "react";
// import styles from "../../../LeftNavigation/DesignerControls/BasicControls.module.css"

function SvgSaveIcon() {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" width="12.653" height="12.653" viewBox="0 0 12.653 12.653">
      <defs></defs>
      <g transform="translate(-4 -4)">
      <path fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M14.859,16.153H5.795A1.3,1.3,0,0,1,4.5,14.859V5.795A1.3,1.3,0,0,1,5.795,4.5h7.121l3.237,3.237v7.121A1.3,1.3,0,0,1,14.859,16.153Z"/>
      <path fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M16.974,24.679V19.5H10.5v5.179" transform="translate(-3.41 -8.526)"/>
      <path fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M10.5,4.5V7.737h5.179" transform="translate(-3.41)"/>
      </g>
      </svg>
  );
}

export default SvgSaveIcon;